import { func, shape, number } from 'prop-types';
import React from 'react';
import { View } from 'react-native';

import { C, SHAPE } from '../../common';
import { ENV, LAYOUT, THEME } from '../../reactor/common';
import { Image, Motion, Video } from '../../reactor/components';
import {
  Chapter, Content, Footer, Gallery, Media, Slider, Title,
} from './components';
import styles from './Page.style';

const { PAGE_TYPE } = C;
const { IS_SERVER } = ENV;
const { COLOR, MOTION: { DURATION } } = THEME;
const children = {
  chapter: Chapter,
  content: Content,
  footer: Footer,
  gallery: Gallery,
  media: Media,
  slider: Slider,
  title: Title,
};

const Page = ({
  data = {}, index, onLayout, onLoad, visibility, ...inherit
}) => {
  const {
    background = {},
    color = !background.color || background.color === COLOR.WHITE
      ? COLOR.TEXT
      : COLOR.WHITE,
    motion,
    type,
  } = data;
  const {
    image, loop = true, muted = true, opacity, video,
  } = background;
  const { VIEWPORT: { PORTRAIT, H, W } } = LAYOUT;
  let isContentWithoutImage = false;
  if (type === PAGE_TYPE.CONTENT) {
    const pageStyle = (data.style || '').split(' ');
    isContentWithoutImage = !data.image && !pageStyle.includes('box') && !pageStyle.includes('centered');
  }

  return (
    <View onLayout={({ nativeEvent: { layout } }) => onLayout(layout)} style={styles.container(data)}>
      { image && ((video && PORTRAIT) || !video)
        && (
        <Motion
          disabled={motion === false}
          delay={isContentWithoutImage ? DURATION / 2 : 0}
          duration={isContentWithoutImage ? DURATION : 10000}
          style={[styles.background, opacity && { opacity }]}
          timeline={[
            isContentWithoutImage
              ? { property: 'translateY', value: inherit.viewed || visibility > 0.1 ? 0 : -H }
              : { property: 'scale', value: ((1 - visibility) / 5) + 1 },
          ]}
        >
          <Image
            onLoad={onLoad}
            responsive
            resizeMode="cover"
            source={{ uri: image }}
            style={{ height: '100%', width: '100%' }}
          />
        </Motion>
        ) }

      { video && (type === PAGE_TYPE.TITLE || !PORTRAIT)
        && (
        <Video
          autoPlay={visibility > 0}
          controls={false}
          loop={loop}
          muted={muted}
          onLoad={onLoad}
          preload
          height={IS_SERVER ? '100vh' : H}
          width={IS_SERVER ? '100vw' : W}
          source={video}
          style={[styles.background, opacity && { opacity }]}
        />
        ) }

      { children[type]
        && React.createElement(children[type], {
          ...data,
          color,
          index,
          visibility,
          ...inherit,
        }) }
    </View>
  );
};

Page.propTypes = {
  data: shape(SHAPE.PAGE).isRequired,
  index: number.isRequired,
  onLayout: func,
  onLoad: func,
  visibility: number.isRequired,
};

Page.defaultProps = {
  onLayout() {},
  onLoad() {},
};

export default Page;
